module.exports = __webpack_public_path__ + "media/images/partner/pic_2-335a4d0c5a1218b8fdbfcc6455ff19f4.png";